module.exports = __webpack_public_path__ + "img/ics_o_truck-booking-black.99656cf2.svg";